import { orange } from "@mui/material/colors";
import { alertTokens, alphaTokens, background, border, button, chartTokens, chip, extractFromMode, field, icon, progressBar, rangeSlider, shapeIcon, table, text, toggle } from "./colorTokens";
const primary = {
    light: orange[50],
    main: orange[100],
    dark: orange[300]
};
const dark = {
    mode: "dark",
    primary,
    destructive: primary,
    quarternary: primary,
    ghostGray: primary,
    ghostPrimary: primary,
    linkGray: primary,
    linkPrimary: primary,
    none: primary,
    gray: primary,
    tertiary: primary,
    neutral: primary,
    tokens: {
        alert: extractFromMode(alertTokens, "light"),
        background: extractFromMode(background, "light"),
        border: extractFromMode(border, "light"),
        button: extractFromMode(button, "light"),
        chip: extractFromMode(chip, "light"),
        field: extractFromMode(field, "light"),
        icon: extractFromMode(icon, "light"),
        progressBar: extractFromMode(progressBar, "light"),
        rangeSlider: extractFromMode(rangeSlider, "light"),
        table: extractFromMode(table, "light"),
        toggle: extractFromMode(toggle, "light"),
        text: extractFromMode(text, "light"),
        shapeIcon: extractFromMode(shapeIcon, "light"),
        alphaTokens: extractFromMode(alphaTokens, "light"),
        chart: extractFromMode(chartTokens, "light")
    }
};
export default dark;

//# sourceMappingURL=dark.js.map